var render, staticRenderFns
import script from "./MsBaseComponent.vue?vue&type=script&lang=js"
export * from "./MsBaseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c213c0ce",
  null
  
)

export default component.exports